import { AuctionsOverviewService } from 'app/_services/auctions-overview.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';

class NetworkPointDetailsRecentAuctionsCtrl implements ng.IController {
    public networkPointId: number;
    public uiLoadingRecentAuctions: boolean = true;
    public recentAuctions: any = [];
    public selectedPeriodType = {};
    public uiRecentAuctionsActivityIsEmpty = false;
    public uiRecentAuctionsAsTable = false;
    public PERIOD_TYPE;

    constructor(
        private auctionResource,
        private auctionsOverviewService: AuctionsOverviewService,
        private $timeout,
        private errorHandler: ErrorHandler
    ) {}

    $onInit(): void {
        this.PERIOD_TYPE = this.auctionsOverviewService.PERIOD_TYPE;
        this.selectPeriodType(this.PERIOD_TYPE.WITHIN_DAY);
        this.getRecentAuctions();
    }

    public getRecentAuctions() {
        this.recentAuctions[this.PERIOD_TYPE.WITHIN_DAY.VALUE] = [];
        this.recentAuctions[this.PERIOD_TYPE.DAILY.VALUE] = [];
        this.recentAuctions[this.PERIOD_TYPE.MONTHLY.VALUE] = [];
        this.recentAuctions[this.PERIOD_TYPE.QUARTERLY.VALUE] = [];
        this.recentAuctions[this.PERIOD_TYPE.YEARLY.VALUE] = [];

        this.auctionResource.capacityGraph(
            { networkPointId: this.networkPointId },
            (res) => {
                angular.forEach(
                    res,
                    (item) => {
                        switch (item.periodType) {
                            case this.PERIOD_TYPE.WITHIN_DAY.VALUE: {
                                angular.forEach(item.curve, (curve) => {
                                    this.recentAuctions[
                                        this.PERIOD_TYPE.WITHIN_DAY.VALUE
                                    ].push(curve);
                                });
                                break;
                            }
                            case this.PERIOD_TYPE.DAILY.VALUE: {
                                angular.forEach(item.curve, (curve) => {
                                    this.recentAuctions[
                                        this.PERIOD_TYPE.DAILY.VALUE
                                    ].push(curve);
                                });
                                break;
                            }
                            case this.PERIOD_TYPE.MONTHLY.VALUE: {
                                angular.forEach(item.curve, (curve) => {
                                    this.recentAuctions[
                                        this.PERIOD_TYPE.MONTHLY.VALUE
                                    ].push(curve);
                                });
                                break;
                            }
                            case this.PERIOD_TYPE.QUARTERLY.VALUE: {
                                angular.forEach(item.curve, (curve) => {
                                    this.recentAuctions[
                                        this.PERIOD_TYPE.QUARTERLY.VALUE
                                    ].push(curve);
                                });
                                break;
                            }
                            case this.PERIOD_TYPE.YEARLY.VALUE: {
                                angular.forEach(item.curve, (curve) => {
                                    this.recentAuctions[
                                        this.PERIOD_TYPE.YEARLY.VALUE
                                    ].push(curve);
                                });
                                break;
                            }
                        }
                    },
                    this.errorHandler
                );

                let firstPeriodTypeToContainAuctions =
                    this.auctionsOverviewService.firstPeriodTypeWithAuctions(
                        res
                    );
                if (!firstPeriodTypeToContainAuctions) {
                    this.uiRecentAuctionsActivityIsEmpty = true;
                } else {
                    this.selectedPeriodType = firstPeriodTypeToContainAuctions;
                }
                this.uiLoadingRecentAuctions = false;
            }
        );
    }

    public selectPeriodType(periodType) {
        if (
            !this.recentAuctions[periodType.VALUE] ||
            !this.recentAuctions[periodType.VALUE].length
        ) {
            return;
        }
        this.selectedPeriodType = periodType;
        if (!this.uiRecentAuctionsAsTable) {
            this.uiLoadingRecentAuctions = true;
            this.$timeout(() => {
                this.uiLoadingRecentAuctions = false;
            }, 30);
        }
    }

    public isPeriodTypeSelected(periodType) {
        return this.selectedPeriodType === periodType;
    }

    public isPeriodTypeAvailableInAuctions(periodType) {
        if (
            angular.isUndefined(this.recentAuctions[periodType.VALUE]) ||
            this.recentAuctions[periodType.VALUE] === null
        ) {
            return false;
        }
        return !!this.recentAuctions[periodType.VALUE].length;
    }

    public getTitleForPeriodTypeSelector(periodType) {
        let periodTypeNormalizedLowerCase = periodType.NORMALIZED.toLowerCase();
        let title = '';
        if (angular.isUndefined(this.recentAuctions[periodType.VALUE])) {
            title =
                'There are no ' +
                periodTypeNormalizedLowerCase +
                ' auctions available.';
            return title;
        }

        let numberOfAuctionsForPeriodType =
            this.recentAuctions[periodType.VALUE].length || false;
        let informationString =
            numberOfAuctionsForPeriodType + ' ' + periodTypeNormalizedLowerCase;

        if (numberOfAuctionsForPeriodType < 1) {
            title =
                'There is no ' +
                periodTypeNormalizedLowerCase +
                ' auction data available.';
        } else if (numberOfAuctionsForPeriodType < 2) {
            title = 'There is ' + informationString + ' auction available.';
        } else {
            title = 'There are ' + informationString + ' auctions available.';
        }

        return title;
    }
}
angular.module('app').component('pkpNetworkPointDetailsRecentAuctions', {
    controller: NetworkPointDetailsRecentAuctionsCtrl,
    template:
        require('app/network-point/network-point-details-recent-auctions.component.html'),
    bindings: {
        networkPointId: '<'
    }
});
